import TableColumnsDialog from '@/components/table/TableColumnsDialog';

// IT資産・消耗品 テーブルの列設定ダイアログ — thin wrapper around the
// generic dialog to keep the existing `asset-col-*` testids working.
export default function AssetColumnsDialog(props) {
  return <TableColumnsDialog {...props} testidPrefix="asset-col" />;
}
